module.exports = __webpack_public_path__ + "static/img/Biometrics.68bdd45.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/technology/Biometrics.jpg
// module id = z+Kh
// module chunks = 1